// extracted by mini-css-extract-plugin
export default {"image":"style-module--image--d3cfa"};